import React from "react";
import { Box, Editor, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicTextEditor = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic File upload
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              'import { Editor } from "convertupleads-theme";\n' +
              "\n\n\n" +
              "const CustomEditor = () => {\n" +
              'const [editorHtml, setEditorHtml] = useState("");' +
              "\n" +
              "  const handleChange = (html) => {\n" +
              "    setEditorHtml(html);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              "      <Editor\n" +
              "        value={editorHtml}\n" +
              "        onChange={handleChange}\n" +
              "      />\n" +
              "  );\n" +
              "}"
            }
          >
            <Editor />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicTextEditor;
